import { httpService } from '@/utils';
import { useToggle } from '@vueuse/shared';
import { ref, computed } from 'vue';
import {
	ConversationMessage,
	useMessages
} from '../composition';

const selectedMessage = ref<ConversationMessage | null>();
const [moveLoading, setMoveLoading] = useToggle();

export function useMoveMessage() {
	const { messages, getSelectedMessage } = useMessages();

	function openDialog(message: ConversationMessage) {
		selectedMessage.value = message;
	}

	function closeDialog() {
		selectedMessage.value = null;
	}

	const hasMessageInTheList = computed(() => {
		return !!messages.value.find(
			(message) =>
				message.uid === selectedMessage.value?.uid
		);
	});

	const isSelectedMessageNotRemoved = computed(() => {
		return (
			hasMessageInTheList.value ||
			!!getSelectedMessage(selectedMessage.value!.uid)
		);
	});

	function moveMessage(
		conversationId: number,
		targetConversationId: number,
		messageUid: string
	) {
		return httpService.post(
			`company/conversations/${conversationId}/messages/${messageUid}/move/${targetConversationId}`
		);
	}

	return {
		selectedMessage: computed(
			() => selectedMessage.value
		),
		isSelectedMessageNotRemoved,
		openDialog,
		closeDialog,
		moveMessage,
		moveLoading: computed(() => moveLoading.value),
		setMoveLoading
	};
}
